import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import Favorite from '../../../assets/images/Favorite-bg4.png'

export default function CarRentalFooterBanner() {
	const place = useSelector((state) => state.place);

	return (
		<section className="section-equal-padding favorite-section uk-scrollspy-inview"
			style={{ backgroundImage: `url(${Favorite})` }}
			uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
			<div className="container d-flex justify-content-center text-center">
				<div className="favorite-block uk-scrollspy-inview"
					uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
					<h2 className="mb-4">Drive Your Journey - Find the Perfect Car Rental Today</h2>
					<p>
						Explore cities, coastlines, and hidden gems at your own pace with our hassle-free car rentals. From
						budget-friendly rides to premium SUVs, we make it easy to book the right car at the right price.
						Secure your rental in minutes and hit the road with confidence.
					</p>

					<Link to={place ? '/deals/:sub' : '/deals'} className="white-btn mt-3">Explore Special Deals</Link>
				</div>
			</div>
		</section>
	)
}
